import { createContext, use } from "react";
import { SURFACE_BASE_LEVEL, type SurfaceLevel } from "./surface-level";

/**
 * React context carrying the current surface (substrate) level.
 *
 * Default = 1 (page substrate). Every <Elevated/> reads this, offsets
 * upward, and re-provides the new level to its descendants — so popovers
 * inside cards inside dialogs all step correctly without anyone passing
 * elevation props through the tree.
 */
export const SurfaceContext = createContext<SurfaceLevel>(SURFACE_BASE_LEVEL);

export const SurfaceProvider = SurfaceContext.Provider;

/** Read the current substrate level. Defaults to 1 outside a provider. */
export function useSurface(): SurfaceLevel {
	return use(SurfaceContext);
}
